/* global $ */

import jump from 'jump.js';
import formSerialize from 'form-serialize';
import moment from 'moment';
import debounce from '../../helpers/debounce';
import { rewriteHistory, getData } from './utils';
import fetchFromAPI from './api';

const $filter = $('.js-filters');
const $clearFilters = $('.js-clear-filters');
const $form = $('.js-filters-form');
const $products = $('.js-filter-products');
const $options = $('.js-filters-options');
const $pagination = $('.js-filter-pagination');
const $remove = $('.js-filters-remove');
const $wrap = $('.js-filters-wrap');
const $pageInput = $('.js-filter-page');
const $results = $('.results__count');
const $locationsOutput = $('#js-locations-output');
const $dateFilterInput = $('.js-date-filter');
const $categoryFilterInput = $('.js-category-filter');
const $categoriesToggler = $('.js-categories-toggler');
const $categoriesTogglerMobile = $('.js-categories-toggler-mobile');
const $dateRangePickerFrom = $('.js-daterangepicker-value-from');
const $dateRangePickerTo = $('.js-daterangepicker-value-to');

const $overlay = $('.js-page-overlay');

const dataType = 'json';

const DEBOUNCE_VAL = 300;

const filter = {
  initialize() {
    moment.locale(document.querySelector('html').getAttribute('lang'));

    if (!$filter.length || !$form.length || !$products.length) {
      // throw new Error('One or more filter elements are missing');
      return;
    }

    this.filtersCombined = () => {
      this.runFilter();
    };

    const debouncedFilters = debounce(this.filtersCombined, DEBOUNCE_VAL);
    const $datepicker = $form.find('.js-daterangepicker');

    if ($dateFilterInput.val() !== '') {
      $(`.js-filter-bar-date > button[data-button-value="${$dateFilterInput.val()}"]`).addClass('is-active');
    }

    $form.add($options).on('click', '.js-filter-bar-date > button', (e) => {
      const $target = $(e.currentTarget);
      $('.js-filter-bar-date > button').removeClass('is-active');

      $dateRangePickerTo.val('');
      $dateRangePickerFrom.val('');
      $('.js-daterangepicker').removeClass('is-active');
      $datepicker.html($datepicker.data('unselected-text'));

      if ($dateFilterInput.val().indexOf($target.data('button-value')) >= 0) {
        $target.removeClass('is-active');
        $dateFilterInput.val('');
      } else {
        $target.addClass('is-active');
        $dateFilterInput.val($target.data('button-value'));
      }

      this.setPageNumber(1);
      this.filtersCombined();
      this.checkFilterGroups();
    });

    let filteredCategories = [];

    if ($categoryFilterInput.val().length !== 0) {
      filteredCategories = $categoryFilterInput.val().split(',').map((str) => parseInt(str, 10));
    }

    if ($('.js-filter-bar-item:hidden > .is-active').length) {
      this.toggleCategories();
    }

    $('.js-filter-bar-category > button').toArray().forEach((button) => {
      const $button = $(button);
      const isActive = filteredCategories.indexOf($button.data('button-value')) >= 0;

      $button.toggleClass('is-active', isActive);
    });

    $form.add($options).on('click', '.js-filter-bar-category > button', (e) => {
      const $target = $(e.currentTarget);

      if (filteredCategories.indexOf($target.data('button-value')) >= 0) {
        $target.removeClass('is-active');
        filteredCategories.splice(filteredCategories.indexOf($target.data('button-value')), 1);
      } else {
        $target.addClass('is-active');
        filteredCategories.push($target.data('button-value'));
      }

      $categoryFilterInput.val(filteredCategories);

      this.setPageNumber(1);
      this.filtersCombined();
      this.checkFilterGroups();
    });

    $form.add($options).on('change', 'input[type="checkbox"], input[type="radio"], select', () => {
      this.setPageNumber(1);
      this.filtersCombined();
      this.checkFilterGroups();
    });

    $form.add($options).on('keyup', 'input[type="text"], input[type="search"], textarea', () => {
      debouncedFilters();
      this.checkFilterGroups();
    });

    if ($dateRangePickerFrom.val() !== '' && $dateRangePickerTo.val() !== '') {
      $datepicker.addClass('is-active');
      const isActive = $datepicker.hasClass('is-active');

      $datepicker
        .find('span')
        .html(isActive
          ? `
            ${moment($dateRangePickerFrom.val(), 'DD-MM-YYYY').format('DD MMM')}
            ${$datepicker.data('until-text')}
            ${moment($dateRangePickerTo.val(), 'DD-MM-YYYY').format('DD MMM')}
            `
          : $datepicker.data('unselected-text'));
    }

    if ($datepicker.length) {
      $datepicker.on('apply.daterangepicker', (e, picker) => {
        $dateRangePickerFrom.val(picker.startDate.format('DD-MM-YYYY'));
        $dateRangePickerTo.val(picker.endDate.format('DD-MM-YYYY'));
        const $target = $(e.currentTarget);
        $target.toggleClass('is-active');

        const isActive = $target.hasClass('is-active');

        $target
          .find('span')
          .html(isActive
            ? `${picker.startDate.format('DD MMM')} ${$target.data('until-text')} ${picker.endDate.format('DD MMM')}`
            : $target.data('unselected-text'));

        $dateFilterInput.val('');
        $('.js-filter-bar-date > button').removeClass('is-active');

        debouncedFilters();
        this.checkFilterGroups();
      });
    }

    $clearFilters.on('click', (e) => {
      const $el = $(e.currentTarget);
      const $filterFields = $el.parents('.js-filter-bar-item').find('input, select');

      $filterFields.each((i, el) => {
        if (el.tagName === 'INPUT' && el.getAttribute('type') === 'checkbox') {
          el.checked = false;
        } else {
          el.value = '';
        }
      });

      this.runFilter();
      this.checkFilterGroups();
    });

    $pagination.on('click', 'a', (e) => {
      e.preventDefault();
      const $el = $(e.currentTarget);
      let page = $el.data('page');

      if (typeof page === 'undefined') {
        return true;
      }

      page = parseInt(page, 10);

      this.setPageNumber(page);
      this.filtersCombined();
      this.scrollToTop();

      return false;
    });

    $remove.on('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      $form.find('input[type="checkbox"], input[type="radio"]')
        .prop('checked', false)
        .removeAttr('checked');

      const inputs = $form.find('.js-category-filter, .js-date-filter, .js-daterangepicker-value-from, .js-daterangepicker-value-to');

      inputs.toArray().forEach((input) => {
        input.value = '';
      });

      const hasFiltersApplied = inputs.toArray().some((input) => input.value !== '');

      if (!hasFiltersApplied) {
        $remove.removeClass('is-open');
      }

      $('.js-filter-bar-item > button').removeClass('is-active');

      $datepicker.val('');
      $datepicker.data('daterangepicker').setStartDate(new Date());
      $datepicker.data('daterangepicker').setEndDate(new Date());
      $datepicker.html($datepicker.data('unselected-text'));

      this.filtersCombined();
    });

    $categoriesTogglerMobile.on('click', (e) => {
      const $target = $(e.currentTarget);
      const isOpen = !$target.hasClass('is-open');

      $target.toggleClass('is-open');

      $target.text(isOpen ? $target.data('expanded-text') : $target.data('collapsed-text'));
    });

    $categoriesToggler.on('click', () => {
      this.toggleCategories();
    });

    this.checkDisabledGroups();
    this.checkFilterGroups();
  },

  toggleCategories() {
    const isOpen = !$categoriesToggler.hasClass('is-open');

    $categoriesToggler.toggleClass('is-open');

    $categoriesToggler.text(isOpen ? $categoriesToggler.data('expanded-text') : $categoriesToggler.data('collapsed-text'));

    $('.js-filter-bar-category').toArray().forEach((filterButton) => {
      const isVisible = isOpen ? true : filterButton.className.indexOf('is-always-visible') >= 0;

      $(filterButton).toggleClass('is-visible', isVisible);
    });
  },

  checkFilterGroups() {
    const $groups = $('.js-filter-bar-item');
    let groupHasValues = false;

    $groups.each((i, el) => {
      const $group = $(el);
      const inputs = $group.find('input, select, textarea, button');

      inputs.toArray().forEach((input) => {
        if (input.tagName === 'INPUT' && (input.getAttribute('type') === 'checkbox' || input.getAttribute('type') === 'radio')) {
          if (input.checked) {
            groupHasValues = true;
          }
        } else if (input.value !== '') {
          groupHasValues = true;
        } else if (input.tagName === 'BUTTON' && input.classList.contains('is-active')) {
          groupHasValues = true;
        }
      });
    });

    $remove.toggleClass('is-open', groupHasValues);
  },

  closeDropdowns() {
    $form.find('.js-filter-dropdown').removeClass('is-visible');
    $('.js-filter-toggle').removeClass('is-open');
  },

  getPageNumber() {
    return parseInt($pageInput.val(), 10);
  },

  getApiUrl() {
    return getData($filter, 'filter-api', '');
  },

  getApiMethod() {
    return getData($filter, 'filter-api-method', 'POST');
  },

  setPageNumber(num) {
    $pageInput.val(num);
  },

  scrollToTop() {
    jump($wrap[0], {
      offset: -15,
      a11y: false,
      duration: 150,
    });
  },

  serializeElement(el) {
    const serialized = formSerialize(el, { hash: true });
    return serialized;
  },

  runFilter() {
    const filters = this.serializeElement($form[0]);
    const options = this.serializeElement($options[0]);
    const data = { ...filters, ...options };

    $overlay.addClass('is-visible');

    rewriteHistory(data);

    fetchFromAPI(this.getApiUrl(), this.getApiMethod(), data, dataType, (res) => {
      const $html = $(res);

      this.outputProducts($html.find('.js-filter-products').html());
      this.outputPagination($html.find('.js-filter-pagination').html());
      this.outputCount($html.find('.results__count').html());
      this.outputLocations($html.find('.js-locations-output').html());

      // Reset all locations
      window.LOCATIONS = [];

      const $locations = $html.filter('#js-locations-json');

      if ($locations.length && $locations.html().trim()) {
        window.LOCATIONS = JSON.parse($locations.html()); // eslint-disable-line
      }

      $(window).trigger('render:map');

      $overlay.removeClass('is-visible');
    });
  },

  outputProducts(html) {
    $products.html(html);
  },

  outputPagination(html) {
    $pagination.html(html);
  },

  outputCount(html) {
    $results.html(html);
  },

  outputLocations(html) {
    $locationsOutput.html(html);
  },

  checkDisabledGroups() {
    $('.js-filter-bar-item').each((i, item) => {
      const $checkboxes = $(item).find('input[type="checkbox"]:not(:disabled)');

      $(item).find('.js-filter-toggle').prop('disabled', (!$checkboxes.length));
    });
  },
};

export default filter;
